import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { persistStore } from 'redux-persist'

//Root reducer
import rootReducer from './rootReducer'

const composeEnhancers =
  (typeof window != 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) ||
  compose

export const store = createStore(
  rootReducer,
  {},
  compose(
    applyMiddleware(thunk),
    //DevTools.instrument()
    composeEnhancers()
  )
)

export type RootState = ReturnType<typeof rootReducer>

export const persistor = persistStore(store)
